module.exports = __webpack_public_path__ + "img/egg-8.079c038b.svg";